import { OBJ_APP_BRIDGES } from 'pages/Bridges/ManagerValidation/_constants';
import { OBJ_APP_HP } from 'pages/Bridges/ManagerValidation/_constants';

/**
 * Translates a system ID into its user-facing name.
 *
 * @param {number} appID system identifier.
 * @returns {string} user-facing system name.
 */
export const getSystemName = appID => {
	let result;
	switch (appID) {
		case OBJ_APP_HP.ID:
			result = OBJ_APP_HP.Name;
            break;
		case OBJ_APP_BRIDGES.ID:
			result = OBJ_APP_BRIDGES.Name;
            break;
		default:
			result = OBJ_APP_BRIDGES.Name;
            break;
	}
	return result;
};
